import React from 'react';
import type { LaneCard, ProductTypeId } from '../types';

const PRODUCT_TYPE_LANE_LABEL: Record<ProductTypeId, string> = {
  Course: 'Course',
  Accommodation: 'Accommodation',
  AddOn: 'AddOns',
  Transfer: 'Transfer',
  Fees: 'Standard Fees',
  Package: 'Packages',
};

interface LaneCardDisplayProps {
  card: LaneCard;
  lane: 'include' | 'exclude';
  onRemove: () => void;
  onConfigure: () => void;
}

export const LaneCardDisplay: React.FC<LaneCardDisplayProps> = ({
  card,
  onRemove,
  onConfigure,
}) => {
  const isMirror = !!card.isMirror;

  return (
    <div
      className={`commission-lane-card${isMirror ? ' commission-lane-card--mirror' : ''}`}
      onClick={isMirror ? undefined : onConfigure}
      role={isMirror ? undefined : 'button'}
      tabIndex={isMirror ? undefined : 0}
      onKeyDown={
        isMirror
          ? undefined
          : (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onConfigure();
              }
            }
      }
    >
      <div className="commission-lane-card-content">
        <span className="commission-lane-card-type">
          Product Type : {PRODUCT_TYPE_LANE_LABEL[card.productType]}
        </span>
        <span className="commission-lane-card-summary">{card.summary || 'Specify product'}</span>
      </div>
      {!isMirror && (
        <button
          type="button"
          className="commission-lane-card-remove"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label="Remove"
        >
          x
        </button>
      )}
    </div>
  );
};